import * as React from "react";
import { useRouter } from "next/router";
import { pushSimpleEvent } from "@nju/data-layer";
import { Icon } from "@nju/icons";
import { Button, Panel, Separator, Text } from "@nju/ui";
import { generalErrorMessage } from "@nju/utils";

export function GeneralError() {
  const router = useRouter();

  React.useEffect(() => {
    pushSimpleEvent({
      event: "error_add_sim_card",
      eventName: "OtherError",
    });
  }, []);

  const refresh = React.useCallback(() => {
    router.reload();
  }, [router]);

  return (
    <Panel>
      <div className="flex items-center flex-col">
        <Text
          size={{
            "@onlyMobile": "xl",
            "@fromTablet": "keyM",
          }}
          weight="bold"
        >
          {generalErrorMessage}
        </Text>
        <Separator size="s" tone="invisible" />
        <Icon
          className="w-12 h-12 from-tablet:w-[90px] from-tablet:h-[90px]"
          name="sim-card-error-incircle"
        />
        <Separator size="s" tone="invisible" />
        <Text
          align="center"
          size={{
            "@onlyMobile": "s",
            "@fromTablet": "l",
          }}
        >
          Spróbuj dodać kartę jeszcze raz.
        </Text>
      </div>
      <Separator size="s" tone="invisible" />
      <div className="flex justify-center">
        <Button onPress={refresh} size={{ "@onlyMobile": "s" }}>
          spróbuj ponownie
        </Button>
      </div>
    </Panel>
  );
}
